// this file added by Bearer Web Developer
import { TransportStateEnum } from "../../../states/app-state";

const noAttentionsFunction = (step: TransportStateEnum | null): boolean => {
    return (
        !step || step === TransportStateEnum.RiderOnTheWayToOrigin || step === TransportStateEnum.RiderPickupParcel 
        || step === TransportStateEnum.RiderArrivesToDestination || step === TransportStateEnum.RiderGetsPermissionToDropOff
        || step === TransportStateEnum.RiderCompletedTransport
    )
}
export default noAttentionsFunction;